<template>
  <form
    id="forgot-password"
    class="d-flex justify-content-center"
    @submit.prevent="restoreAccess"
  >
    <div style="width: 320px">
      <p class="text-center">
        <img
          alt="ТЭК-Торг Электронный документооборот"
          src="@/assets/logo.png"
        />
      </p>

      <h4 class="pt-2 pb-2 highlighting">
        Восстановить доступ
      </h4>

      <b-form-input
        v-model="email"
        type="text"
        :state="emailValid"
        :maxlength="EMAIL_LENGTH"
        class="mt-2"
        placeholder="Адрес электронной почты"
      />

      <b-button-group class="d-flex mt-2">
        <b-button variant="edo" size="sm" @click="$router.push('/')"
          >Назад</b-button
        >
        <b-button v-if="loading" variant="edo" size="sm" disabled>
          Восстановить <b-spinner small type="grow" />
        </b-button>
        <b-button
          v-else
          type="submit"
          variant="edo"
          size="sm"
          :disabled="!emailValid"
          >Восстановить</b-button
        >
      </b-button-group>
      <Error
        v-if="errorText"
        :error-details="moreErrorInfo"
        :error-text="errorText"
        :large-text="false"
      />

      <p v-if="successText" class="pt-2 small font-weight-bold text-success">
        {{ successText }}
      </p>
    </div>
  </form>
</template>

<script>
import axios from 'axios'
import Error from '@/components/error'
import { emailRegExp } from '@/utils'
import { securityActor } from '@/urls'

export default {
  name: 'ForgotPassword',
  components: {
    Error
  },
  data: () => ({
    successText: '',
    errorText: '',
    moreErrorInfo: '',
    loading: false,
    email: '',
    EMAIL_LENGTH: 99
  }),
  computed: {
    emailValid() {
      return !!(this.email.length && emailRegExp.test(this.email))
    }
  },
  methods: {
    async restoreAccess() {
      this.successText = ''
      this.errorText = ''
      this.moreErrorInfo = ''
      this.loading = true
      try {
        const url = `${securityActor}/password-reset/request?email=${this.email}`
        await axios.post(url, null)
        this.successText = `На адрес электронной почты: ${this.email} отправлено письмо с данными для восстановления пароля`
      } catch (error) {
        const { status } = error.response
        if (status === 404) {
          this.errorText = `Пользователя с адресом электронной почты ${this.email} не существует, либо почта не была подтверждена. Обратитесь в службу поддержки`
        } else {
          this.moreErrorInfo = error.response
          this.errorText = 'Ошибка восстановления пароля'
        }
        throw error
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
